import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { MultiSelect } from 'primereact/multiselect';
import { StyledContainerMethodWithValue } from '../sideBarComponentsStyles';
import Strings from '../../../../i18n';

interface MultiSelectWithChipsAndSendButtonSideBarProps {
  label: string;
  selectedValues: { name: string; id: number }[];
  setSelectedValues: (values: { name: string; id: number }[]) => void;
  action: () => void;
  buttonLabel?: string;
  options: { name: string; id: number }[];
  onChange: (values: { name: string; id: number }[]) => void;
  showFilter?: boolean;
  showClear?: boolean;
  showSelectAll?: boolean;
  placeholder?: string;
}
export const MultiSelectWithChipsAndSendButtonSideBar = ({
  label,
  selectedValues,
  setSelectedValues,
  action,
  buttonLabel,
  options,
  onChange,
  showFilter,
  showClear,
  showSelectAll,
  placeholder
}: MultiSelectWithChipsAndSendButtonSideBarProps) => {
  return (
    <StyledContainerMethodWithValue container>
      <Grid item xs={12}>
        <div className="label">{label}</div>
        <div className="value">
          <div className="card flex justify-content-center">
            <MultiSelect
              value={selectedValues}
              onChange={(e) => {
                onChange(e.value);
              }}
              options={options}
              optionLabel="name"
              display="chip"
              className="w-100"
              placeholder={placeholder || 'Select Apps'}
              appendTo="self"
              filter={showFilter}
              showClear={showClear}
              showSelectAll={showSelectAll}
            />
          </div>
        </div>
      </Grid>
    </StyledContainerMethodWithValue>
  );
};
MultiSelectWithChipsAndSendButtonSideBar.defaultProps = {
  buttonLabel: Strings.common.send,
  showFilter: false,
  showClear: false,
  showSelectAll: false,
  placeholder: undefined
};
